import React from "react";
import videobg from "../videos/Heart logo (Crimson).mp4";

const Services = () => {
  // services details
  const services = [
    {
      name: "Feroze Mahmood, MD, FASE",
      title: "MD FASE",
      desc: "Professor of Anesthesia Harvard Medical School; Network Chief - Cardiac Anesthesia, Beth Israel Deaconess Medical Center",
      icon: "images/Course Directors/Feroze Mahmood.png",
    },
    {
      name: "Ruma Bose, MD",
      title: "MD",
      desc: "Assistant Professor of Anesthesia, Harvard Medical School; Program Director of Cardiothoracic Anesthesia Fellowship, Beth Israel Deaconess Medical Center",
      icon: "images/Course Directors/Ruma Bose.png",
    },
    {
      name: "Aidan Sharkey, MD",
      title: "MD",
      desc: "Instructor in Anesthesia, Beth Israel Deaconess Medical Center, Harvard Medical School",
      icon: "images/Course Directors/Aidan Sharkey.png",
    },
    {
      name: "Sohail Mahboobi, MD, FASA",
      title: "MD, FASA",
      desc: "Assistant Professor of Anesthesiology, Tufts University School of Medicine; Vice-chair (Education) Lahey Hospital & Medical Center",
      icon: "images/Course Directors/Mahboobi Sohail.png",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        <video
          src={videobg}
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            objectFit: "cover",
          }}
        />

        <h2 className="text-10 fw-600 offset-lg-1 mb-1 mt-5 text-center wow fadeInUp">
          <span style={{ color: "#AE2A2F" }} className="fw-700">
            Course Directors
          </span>
        </h2>

        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-3 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <img
                      width={150}
                      height={150}
                      className="img-fluid rounded-pill d-block"
                      src={service.icon}
                      alt="pic"
                    />
                  </div>
                  <p className="fw-600 mb-0">{service.name}</p>
                  <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                    {service.desc}{" "}
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
